import { useEffect, useRef } from 'react';

/**
 * Runs `reset` when an Overview link opens a list (`show` changes to a new
 * value), so the list starts from exactly the rows the link counted. It does
 * not run on the first render: a table that mounts with `show` already in the
 * URL (Back from a request, a reload) restores its own saved search and
 * filter from the URL, which the reset would wipe.
 */
export function useListLinkReset(show, reset) {
    const previous = useRef(show);
    useEffect(() => {
        if (show && show !== previous.current) reset();
        previous.current = show;
    }, [show, reset]);
}

export default useListLinkReset;
